<template>
		<router-view></router-view>
</template>

<script>
	export default {
		name: 'App',
		components: {},
	
	}
</script>
<style>

	@import './assets/css/global.css';
	body{
		margin: 0;
		padding: 0;

	}
	 .inner {
	    overflow: auto;
	  }
	  .inner::-webkit-scrollbar {
	    width: 0 !important;
	  }
	  .border{
		  border: 1px solid red;
	  }
	  div{
		  padding:0;
		  margin: 0;
		  box-sizing: border-box;
	  }
	  input{
	  	border: 0;
	  	background: none;
	  	 outline: none;/*清除input点击之后的黑色边框*/
	  }
	  textarea{
	  	border: 0;
	  	resize: none;
	  	background: none;
	  	 outline: none;/*清除input点击之后的黑色边框*/
	  }
	 .header_form .el-form-item{
		  margin-bottom: 0;
	  }
	  .el-card{
		  margin-bottom: 10px;
	  }
</style>